import React from 'react';
import { useStyletron } from 'baseui';
import { ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { Textarea } from 'baseui/textarea';
import { HeadingSmall } from 'baseui/typography';
import { useReportQAContext } from '../../../context';
const ResultsModalContent = () => {
  const [css] = useStyletron();
  const [, mutate, query] = useReportQAContext();
  const {
    result
  } = query(state => state.modal);
  return <>
      <ModalHeader>Report QA - Results</ModalHeader>
      <ModalBody>
        <div className={css({
        maxHeight: '60vh'
      })}>
          <HeadingSmall>Results</HeadingSmall>
          <Textarea value={result} overrides={{
          Input: {
            style: {
              minHeight: '50vh'
            }
          }
        }} />
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={() => {
        mutate(state => ({
          ...state,
          modal: {
            ...state.modal,
            content: 'config'
          }
        }));
      }}>
          Back
        </ModalButton>
      </ModalFooter>
    </>;
};
export default ResultsModalContent;